import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { TOOL_COMPONENT_IDS } from '../../constants/componentAccess';
import { getCachedDecodedToken, hasComponentAccess, getCachedUserRole, ROLE_COMPONENT_IDS } from '../../services/auth.service';
import './LeftNavPanel.css';

function LeftNavPanel({ isOpen, onClose }) {
  const navigate = useNavigate();
  const location = useLocation();
  const tokenData = getCachedDecodedToken();
  const role = getCachedUserRole();

  const isAdmin = role === ROLE_COMPONENT_IDS.ADMIN;

  const allTools = [
    // {
    //   id: 'idea-management',
    //   name: 'Ideas',
    //   icon: '💡',
    //   path: '/ideas',
    //   description: 'Submit, review and manage ideas through the evaluation workflow',
    // },
    {
      id: 'idea-analyzer',
      name: 'Idea Analyzer',
      icon: '📊',
      path: '/tools/idea-analyzer',
      description: 'Analyze and evaluate business ideas with AI',
    },
    {
      id: 'code-generator',
      name: 'Code & Test',
      icon: '💻',
      path: '/tools/code-generator',
      description: 'Generate code and test cases',
    },
    // {
    //   id: 'sdlc',
    //   name: 'SDLC Workspace',
    //   icon: '🧭',
    //   path: '/tools/sdlc/idea',
    //   description: 'End-to-end SDLC: idea → requirements → design → docs → code → tests → CI/CD → deploy',
    // },
    // {
    //   id: 'pipeline',
    //   name: 'AI Delivery Pipeline',
    //   icon: '🤖',
    //   path: '/tools/pipeline',
    //   description: 'Agentic pipeline: requirements → design → docs → code → tests → CI/CD → AWS deploy',
    // },
    {
      id: 'studio',
      name: 'AI Studio',
      icon: '🧠',
      path: '/tools/studio',
      description: 'AI-guided SDLC requirements chatbot — chat your way to structured requirements',
    },
  ];

  const tools = allTools.filter((t) => {
    const ids = TOOL_COMPONENT_IDS[t.id];
    if (!ids) return true;
    return hasComponentAccess(tokenData, ids);
  });

  const isActive = (path) => location.pathname.startsWith(path);

  const handleToolClick = (path) => {
    navigate(path);
    onClose();
  };

  return (
    <>
      {isOpen && <div className="nav-overlay" onClick={onClose} />}

      <div className={`left-nav-panel ${isOpen ? 'open' : ''}`}>
        <div className="left-nav-header">
          <h3>Navigation</h3>
        </div>

        <div className="left-nav-tools">
          {tools.map(tool => (
            <div
              key={tool.id}
              className={`tool-item ${isActive(tool.path.replace('/idea', '')) ? 'active' : ''}`}
              onClick={() => handleToolClick(tool.path)}
              title={tool.description}
            >
              <div className="tool-icon">{tool.icon}</div>
              <div className="tool-name">{tool.name}</div>
            </div>
          ))}
        </div>

        {/* Admin section */}
        {isAdmin && (
          <>
            <div className="left-nav-header" style={{ marginTop: 12, paddingTop: 12, borderTop: '1px solid #e2e8f0' }}>
              <h3>Admin</h3>
            </div>
            <div className="left-nav-tools">
              <div
                  className={`tool-item ${isActive('/admin') ? 'active' : ''}`}
                  onClick={() => { navigate('/admin'); onClose(); }}
                  title="Manage IAS entities and administration"
              >
                <div className="tool-icon">🔐</div>
                  <div className="tool-name">Admin</div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default LeftNavPanel;
